export default __webpack_public_path__ + "static/media/imgPlaceholder-3d.aca70841.jpg";